import React from "react";
import { Flex } from "@mantine/core";
import { formatShortDate } from "../app/routes/admin/selectors";

export const isDueDateOverdue = (dueDate: unknown, isComplete: boolean): boolean => {
  if (dueDate == null || dueDate === "" || isComplete) {
    return false;
  }

  const dueDateTime = dueDate instanceof Date ? dueDate.getTime() : new Date(dueDate as string).getTime();

  return Number.isNaN(dueDateTime) === false && Date.now() > dueDateTime;
};

const DisplayDueDate: React.FC<any> = ({ dueDate, isComplete, color = "black" }) => {
  const dueDateIsPassed = isDueDateOverdue(dueDate, isComplete);
  return (
    <>
      {dueDate != null && dueDate !== "" && (
        <Flex align="center" p={0} m={0}>
          {dueDateIsPassed && isComplete === false && <i className="fa fa-warning fa-fw icon-danger" />}
          {dueDateIsPassed === false && <i className="fa fa-clock-o fa-fw" />}
          <span style={{ color: dueDateIsPassed && isComplete === false ? "red" : color || "#a3a3a3" }}>
            {formatShortDate(dueDate)}
          </span>
        </Flex>
      )}
    </>
  );
};

export default DisplayDueDate;
